import * as types from "../actions/ActionTypes";
import { agencyInitial } from "../store/InitialStore";

export default function AgencyDetailsReducer(state = agencyInitial, action) {
  const { type, payload } = action;

  switch (type) {
    case types.AGENCY_DETAILS_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case types.AGENCY_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        ...payload,
        error: false,
      };
    case types.AGENCY_DETAILS_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      };
    default:
      return state;
  }
}
